export const SkeletonTestIds = {
  CHECKBOX: 'skeleton.checkbox',
};
